

import { Tag } from "antd";
import {
  CheckCircleOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";

export const listStatusTrip = [
  {
    label: "Hoạt động",
    value: "active",
    tag: (
      <Tag color="success" icon={<CheckCircleOutlined />}>
        Hoạt động
      </Tag>
    ),
  },
  {
    label: "Ẩn",
    value: "hidden",
    tag: (
      <Tag color="red" icon={<EyeInvisibleOutlined />}>
        Ẩn
      </Tag>
    ),
  },
];